import axios from 'axios'
import { ElMessage } from 'element-plus'
import prefixEve from 'src/utils/routeFilter.js'

const prefix = prefixEve.cuttingFiler()
axios.defaults.timeout = 100000 // 请求超时时间

// 登录超时统一处理：清 token 并跳回登录页
const handleLoginTimeout = () => {
  if (prefix === '/boss') {
    window.localStorage.bosstoken = ''
  } else {
    window.localStorage.enterprisetoken = ''
  }
  ElMessage.closeAll()
  ElMessage({
    message: '登录超时',
    type: 'warning',
    duration: 1000,
    onClose: () => {
      const loginPath = `${prefix}/login`
      // 携带 redirect 回跳参数（含完整 query，如 OAuth 授权参数）；已在登录页时不拼，避免自指循环
      const redirect =
        window.location.pathname === loginPath
          ? ''
          : `?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`
      window.location.href = `${loginPath}${redirect}`
    }
  })
}

// 响应拦截器：仅在模块加载时注册一次，避免每次请求都累加重复执行
axios.interceptors.response.use(
  (response) => {
    const body = response.data || {}
    const code = Number(body.code)
    if (code === 0) {
      return response
    }
    if (code === 41001 || code === 41002) {
      handleLoginTimeout()
      return Promise.reject(body)
    }
    // silent 请求（如可选的兜底查询）不弹全局错误提示，由调用方自行处理
    if (!response.config?.silent) {
      ElMessage.closeAll()
      // 错误文案兼容两套结构：本地 mock 用 msg，真实后端用 message
      ElMessage({ message: body.msg || body.message || '请求失败', type: 'warning' })
    }
    return Promise.reject(body.msg || body.message || body)
  },
  (error) => {
    ElMessage.closeAll()
    // 优先展示后端信封里的业务错误文案（如删除服务商被拒 409 时 message 说明原因）
    const errBody = error.response && error.response.data
    const serverMsg = errBody && typeof errBody === 'object' ? errBody.message || errBody.msg : ''
    const statusText =
      serverMsg || (error.response && error.response.status ? `错误信息：status: ${error.response.status}` : '网络错误')
    ElMessage({ message: statusText, type: 'warning' })
    return Promise.reject(error)
  }
)

/**
 * 统一请求封装
 * 约定接口返回结构：{ code, data, page?, msg }
 * - code: 0 成功 / 41001 没有穿请求头token / 41001 登录超时 / 其他失败
 * - 成功 resolve 整个 body，失败 reject(msg)
 */
export default function (type = 'get', url, data, formFile = false, silent = false) {
  return new Promise((resolve, reject) => {
    const headers = {
      Authorization: `Bearer ${prefix === '/boss' ? window.localStorage.bosstoken : window.localStorage.enterprisetoken}`,
      'Content-Type': formFile
        ? 'multipart/form-data'
        : 'application/json'
    }
    type = type.toLowerCase()
    const config = {
      method: type,
      headers,
      url,
      silent
    }
    if (type === 'get') {
      config.params = data
    } else if (type === 'post') {
      // 空入参 POST 兜底为空对象，确保始终携带请求体与 Content-Type（后端要求已注册的 Content-Type）
      config.data = data ?? {}
    }

    axios(config)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err))
  })
}
